import "./ManagerTabs.css";

const sharedTabs = [
  { key: "dashboard", label: "אישורי הגעה", mobileLabel: "אישורים" },
  { key: "edit", label: "הגדרות הזמנה", mobileLabel: "הגדרות" },
];

const contactTabs = [
  { key: "settings", label: "אנשי קשר", mobileLabel: "אנשי קשר" },
  { key: "seating", label: "סידורי הושבה", mobileLabel: "הושבה" },
];

const TabIcon = ({ tabKey }) => {
  if (tabKey === "dashboard") {
    return <svg viewBox="0 0 24 24"><path d="M4 12.5 9 17l11-11" /></svg>;
  }
  if (tabKey === "edit") {
    return <svg viewBox="0 0 24 24"><path d="m4 16-.8 4 4-.8L18.5 7.9l-3.2-3.2L4 16Z" /><path d="m13.8 6.2 3.2 3.2" /></svg>;
  }
  if (tabKey === "upgrades") {
    return <svg viewBox="0 0 24 24"><rect x="3" y="8" width="18" height="4" rx="1" /><path d="M5 12v9h14v-9M12 8v13" /><path d="M12 8H8a3 3 0 1 1 3-3l1 3Zm0 0h4a3 3 0 1 0-3-3l-1 3Z" /></svg>;
  }
  if (["messages", "autopilot"].includes(tabKey)) {
    return <svg viewBox="0 0 24 24"><path d="m3 11 18-8-8 18-2.2-7.8L3 11Z" /><path d="m10.8 13.2 5.5-5.5" /></svg>;
  }
  if (tabKey === "settings") {
    return <svg viewBox="0 0 24 24"><circle cx="9" cy="8" r="3" /><path d="M3.5 19c.4-3.2 2.2-5 5.5-5s5.1 1.8 5.5 5" /><circle cx="17" cy="9" r="2" /><path d="M15.5 14.5c3-.8 5 .5 5.5 3.5" /></svg>;
  }
  return <svg viewBox="0 0 24 24"><rect x="5" y="7" width="14" height="10" rx="3" /><path d="M8 4v3M16 4v3M8 17v3M16 17v3" /></svg>;
};

const ManagerTabs = ({ activeTab, onTabClick, onPreview, previewDisabled = false, packageEvent = false, packageStatusReady = true }) => {
  const showUpgrades = packageStatusReady && !packageEvent;
  const messagingTab = packageEvent
    ? { key: "autopilot", label: "הודעות לאורחים", mobileLabel: "הודעות" }
    : { key: "messages", label: showUpgrades ? "חבילות ושדרוגים" : "שליחת הודעות", mobileLabel: showUpgrades ? "שדרוגים" : "הודעות", upgrade: showUpgrades };
  const tabs = [...sharedTabs, messagingTab, ...contactTabs];
  return (
    <nav className="manager-tabs" aria-label="תפריט ניהול">
      {tabs.map((tab) => (
      <button
        key={tab.key}
        type="button"
        className={`manager-tabs__item ${activeTab === tab.key ? "manager-tabs__item--active" : ""}${tab.upgrade ? " manager-tabs__item--upgrade" : ""}`}
        onClick={() => onTabClick(tab.key)}
        aria-current={activeTab === tab.key ? "page" : undefined}
        aria-label={tab.label}
      >
        <span className="manager-tabs__icon" aria-hidden="true"><TabIcon tabKey={tab.upgrade ? "upgrades" : tab.key} /></span>
        <span className="manager-tabs__label manager-tabs__label--desktop">{tab.label}</span>
        <span className="manager-tabs__label manager-tabs__label--mobile">{tab.mobileLabel}</span>
      </button>
      ))}
      <button
      type="button"
      className="manager-tabs__preview"
      onClick={onPreview}
      disabled={previewDisabled}
      aria-label="תצוגה מקדימה של ההזמנה לאורח"
      title="תצוגת אורח"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M2.2 12s3.6-6 9.8-6 9.8 6 9.8 6-3.6 6-9.8 6-9.8-6-9.8-6Z" />
        <circle cx="12" cy="12" r="3.2" />
      </svg>
      <span>צפייה בהזמנה</span>
      </button>
    </nav>
  );
};

export default ManagerTabs;
